
import React from 'react'

export default function EmptyCell (props) {
  if (props.isBloodOxygen) return <div className='members-list__empty '><em>No SpO₂ data</em></div>
  return <div className='members-list__empty'><em>{props.message}</em></div>
}
